import * as Sentry from "@sentry/react";
import { clsx } from "clsx";
import {
  type ForwardedRef,
  forwardRef,
  type ImgHTMLAttributes,
  useEffect,
  useState,
} from "react";

import Skeleton from "common/components/ui/Skeleton";

export type LoadableImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  fallbackImage?: string;
};

function LoadableImage(
  { src, fallbackImage = null, className, ...rest }: LoadableImageProps,
  ref: ForwardedRef<HTMLImageElement>,
) {
  const [isError, setIsError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  let profileImage = fallbackImage;
  if (!isError && src) {
    profileImage = src;
  }

  //reset state on src url change
  useEffect(() => {
    if (src) {
      setIsError(false);
      setIsLoaded(false);
    }
  }, [src]);

  return (
    <>
      {!isLoaded && <Skeleton className={className} />}
      <img
        ref={ref}
        className={clsx(
          !isLoaded && "hidden",
          "shrink-0 data-hj-suppress",
          className,
        )}
        alt=""
        src={profileImage}
        onError={() => {
          Sentry.setExtra("src", src);
          Sentry.captureMessage("Profile Image error");
          setIsError(true);
        }}
        onLoad={() => setIsLoaded(true)}
        {...rest}
      />
    </>
  );
}

LoadableImage.displayName = "LoadableImage";

export default forwardRef(LoadableImage);
